export default {"src":"/_next/static/media/member-taking-medication-alcohol.mono.0599215e.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};